export default {
  getEvent(state) {
    return state.event;
  },
};
